import React from "react";
import { useTheme } from "../../../../../hooks";
import { Link } from "../../../../links";
const CustomLink = ({ children, to, hovered, active, isVertical, customLinkComponent }) => {
    // hooks
    const { Theme } = useTheme();
    if (!!customLinkComponent) {
        const LinkComponent = customLinkComponent;
        return (React.createElement(LinkComponent, { href: to, style: {
                ...Theme.link,
                color: hovered
                    ? Theme.nav[isVertical ? "vertical" : "horizontal"].nav.hover.color
                    : active
                        ? Theme.nav[isVertical ? "vertical" : "horizontal"].nav.active.color
                        : Theme.nav[isVertical ? "vertical" : "horizontal"].nav.color,
                fontSize: "1rem",
            } }, children));
    }
    return (React.createElement(Link, { to: to, styles: {
            ...Theme.link,
            color: hovered
                ? Theme.nav[isVertical ? "vertical" : "horizontal"].nav.hover.color
                : active
                    ? Theme.nav[isVertical ? "vertical" : "horizontal"].nav.active.color
                    : Theme.nav[isVertical ? "vertical" : "horizontal"].nav.color,
            size: "1rem",
            hover: Theme.nav[isVertical ? "vertical" : "horizontal"].nav.hover.color,
        } }, children));
};
export default CustomLink;
//# sourceMappingURL=CustomLink.js.map